import { ImpactJwtResponse, ImpactJwtUser } from './useImpactJwt.interface';

import collectiveApi from 'modules/common/collectiveApi';

export default async function fetchImpactJwt(user: ImpactJwtUser): Promise<string | null> {
    const { data } = await collectiveApi.post<ImpactJwtResponse>('/impact/jwt/generate/', {
        user: {
            id: user.email,
            accountId: user.email,
            email: user.email,
            firstName: user.firstName ?? '',
            lastName: user.lastName ?? '',
            ...(user.cookies && { cookies: user.cookies }),
        },
    });

    return data.success ? data.data?.jwt ?? null : null;
}
